import { Injectable, Type, Optional, Inject } from '@angular/core';
import {
  JeevesCheckoutConfigService,
  AssignJeevesDefaultsComponent,
  AssignOrderRowsJeevesComponent,
  DeliveryLocationsJeevesComponent,
  SummarizeOrderJeevesComponent,
  JeevesDeliveryAddressStepComponent,
  JeevesCustomerConfigService
} from 'gung-standard-jeeves';
import {
  CheckoutStepComponent,
  AuthService,
  CartSalesStepComponent,
  CartTotalStepComponent,
  GungFlowService,
  NavigationConfig,
  ButtonsComponent
} from 'gung-standard';
import { Observable } from 'rxjs';
import { map, first } from 'rxjs';
import { RefCheckoutDefaultsComponent } from '../components/ref-checkout-defaults/ref-checkout-defaults.component';
import { Router } from '@angular/router';
import { RefOrderTermsJeevesComponent } from '../components/checkout/steps/ref-order-terms-jeeves/ref-order-terms-jeeves.component';
import { RefDeliveryLocationsJeevesComponent } from '../components/ref-delivery-locations-jeeves/ref-delivery-locations-jeeves.component';
import { CapstoneDeliveryAddressStepComponent } from '../components/capstone/capstone-delivery-address-step/capstone-delivery-address-step.component';
import { RefButtonsComponent } from '../components/checkout/ref-buttons/ref-buttons.component';

export interface RefEnvironment extends NavigationConfig {
  projectName: string;
}

@Injectable({
  providedIn: 'root'
})
export class RefCheckoutConfigService extends JeevesCheckoutConfigService {
  isRef = this.environment.projectName === 'ref';
  enableDiscount = !this.isRef;

  constructor(
    router: Router,
    protected authService: AuthService,
    protected gungFlowService: GungFlowService,
    jeevesCustomerConfigService: JeevesCustomerConfigService,
    @Optional()
    @Inject('environment')
    protected environment: RefEnvironment
  ) {
    super(router, authService, gungFlowService, jeevesCustomerConfigService, environment);
  }

  getInternalPreProcessSteps(): Observable<Type<CheckoutStepComponent>[]> {
    return super.getInternalPreProcessSteps().pipe(
      map(d => {
        d[d.indexOf(AssignJeevesDefaultsComponent)] = RefCheckoutDefaultsComponent;
        return d;
      })
    );
  }

  getMainProcessSteps(): Observable<Type<CheckoutStepComponent>[]> {
    return this.authService.getRoles().pipe(
      first(),
      map(roles => {
        const steps = [];
        const filteredRoles = roles.filter(role => role.toUpperCase() === 'ADMIN' || role.toUpperCase() === 'SALES');
        const isSalesOrAdmin = filteredRoles.length > 0;
        if (isSalesOrAdmin) {
          steps.push(CartSalesStepComponent);
        } else {
          steps.push(CartTotalStepComponent);
        }
        steps.push(AssignOrderRowsJeevesComponent);

        if (this.isRef) {
          steps.push(RefDeliveryLocationsJeevesComponent);
        } else {
          steps.push(CapstoneDeliveryAddressStepComponent);
        }

        if (isSalesOrAdmin) {
          steps.push(RefOrderTermsJeevesComponent);
        }

        steps.push(SummarizeOrderJeevesComponent);
        return steps;
      })
    );
  }

  getButtonsComponent(): Type<ButtonsComponent> {
    return RefButtonsComponent;
  }
}
